import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
export function ScarcityBar() {
  const [left, setLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(l => l > 3 ? l - 1 : l);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const pct = (TOTAL_SPOTS - left) / TOTAL_SPOTS * 100;
  return <div className="w-full max-w-xl rounded-2xl bg-white p-4 ring-2 ring-red-200" data-id="element-283" data-mp="2b8us9sqzoi0x">
      <p className="flex items-center justify-center gap-2 text-center text-base font-extrabold text-red-600" data-id="element-284" data-mp="2g7eelu9hvvtt">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-285" data-mp="227wo9agjwaic" />
        Only {left} spots left at the promotional price!
      </p>
      <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-red-100" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-286" data-mp="eyoeuocwhnw">
        <motion.div className="flex h-full items-center justify-end rounded-full bg-red-600 pr-2" initial={{
        width: '60%'
      }} whileInView={{
        width: `${pct}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-287" data-mp="33ks7zabjs7ov">
          <span className="text-[11px] font-extrabold text-white" data-id="element-288" data-mp="38fobp7q5cjht">{Math.round(pct)}% claimed</span>
        </motion.div>
      </div>
    </div>;
}